var map = {
	"./account-block": 69645,
	"./auction-catalogue-block": 94060,
	"./auction-catalogue-block.jsx": 94060,
	"./calculator-block": 67000,
	"./checkout-block": 25743,
	"./collapse-expand-block": 613,
	"./confirmation-block": 63394,
	"./content-hub-block": 33600,
	"./countdown-block": 15845,
	"./custom-block": 91795,
	"./footer-navigation-block": 30680,
	"./form-block": 91677,
	"./gallery-block": 48488,
	"./header-block": 72742,
	"./hidden-block": 30403,
	"./hidden-block.jsx": 30403,
	"./iframe-block": 14947,
	"./list-of-items-block": 62676,
	"./locations-block": 61459,
	"./placeholder-block": 39300,
	"./placeholder-block.jsx": 39300,
	"./popup-block": 24093,
	"./product-access-block": 95079,
	"./product-block": 84495,
	"./product-search-block": 97913,
	"./products-block": 6223,
	"./products-list-block": 80509,
	"./registration-block": 61705,
	"./reviews-list-block": 42426,
	"./reviews-summary-block": 93770,
	"./site-navigation-block": 59287,
	"./spacer-block": 18395,
	"./text-block": 77872,
	"./text-media-block": 35601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16627;